module.exports = __webpack_public_path__ + "static/media/b2b-gif.a94893af.gif";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/b2b-gif.gif
// module id = 298
// module chunks = 0